function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-8dd7cb0c\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FamilyArgeeMent.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./FamilyArgeeMent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8dd7cb0c\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FamilyArgeeMent.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8dd7cb0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modules/familyDoctor/FamilyArgeeMent.vue
// module id = 708
// module chunks = 0